import React, { useCallback, useEffect, useState, KeyboardEvent } from 'react'
import moment from 'moment'
import ReactPaginate from 'react-paginate'
import { useSelector } from 'react-redux'

import DatePicker from 'react-datepicker'
import { KTSVG } from '../../../../../../_metronic/helpers'
import NodataYet from '../../../../../Components/NodataYet'
import {
  useGetUserOrderAdminListQuery,
  useLazyExportUserOrderAdminListQuery,
  useLazyGetCouponListQuery,
  useGetUserOrderAdminSummaryQuery,
} from '../../../../../../services/cellcast.v2'

import { Spinner } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { ENV } from '../../../../../Utils/_helpers/EnvHelper'
import { SalesTarget } from './StaffTarget'
import { getAllUserDetails } from '../../../../UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import { CouponFilter } from '../../../../../../services/cellcast.v2.types'
import WSButton from '../../../../../../_metronic/helpers/components/WSButton/WSButton'
import { showDiscountType } from '../../../../../Utils/coupon'
import { ROLES } from '../../../../../Utils/Constant/roles'

const Commission = () => {
  const API_DOMAIN = ENV().REACT_APP_DOMAIN
  const userDetail = useSelector(getAllUserDetails)

  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)
  const [page, setPage] = useState({
    page: 1,
    size: 10,
  })

  const [isSalesTargetModal, setIsSalesTargetModal] = useState(false)
  const [triggerFetch, setTriggerFetch] = useState(false)

  const today = new Date() // Current date
  const sevenDaysAgo = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000)

  const [dateRange, setDateRange] = useState<any>([sevenDaysAgo, new Date()])
  const [startDate, endDate] = dateRange

  const [params, setParams] = useState<CouponFilter>({
    staffId: ProfileDetatileState?._id,
    page: 1,
    limit: 10,
    search: ''
  })

  const {
    isLoading: commissionLoading,
    data: commissionData,
  } = useGetUserOrderAdminSummaryQuery({
    userId: ProfileDetatileState?._id ?? userDetail?._id,
    fromDate: moment(startDate).format('YYYY-MM-DD'),
    toDate: moment(endDate).format('YYYY-MM-DD'),
  })

  const [exportData, { isLoading }] = useLazyExportUserOrderAdminListQuery()
  const [fetchCoupon, { isLoading: isLoadingCoupon, data, isFetching }] = useLazyGetCouponListQuery()

  useEffect(() => {
    fetchCoupon(params)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (triggerFetch && triggerFetch === true) {
      doFetch(params)
    }
    setTriggerFetch(false)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [triggerFetch])

  const doFetch = useCallback(
    (params) => {
      fetchCoupon(params)
        .then((res) => {
          if ('data' in res) {
          } else if ('error' in res) {
            toast.error(res.error)
          }
        })
        .catch((err) => {
          toast.error(err.error)
        })
    },
    [fetchCoupon]
  )

  const {
    isLoading: commissionListLoading,
    data: commissionListData,
  } = useGetUserOrderAdminListQuery({
    userId: ProfileDetatileState?._id ?? userDetail?._id,
    fromDate: moment(startDate).format('YYYY-MM-DD'),
    toDate: moment(endDate).format('YYYY-MM-DD'),
    ...page,
  })

  const handleExports = useCallback(() => {
    exportData({
      userId: ProfileDetatileState?._id,
      fromDate: moment(startDate).format('YYYY-MM-DD'),
      toDate: moment(endDate).format('YYYY-MM-DD'),
    })
      .then((res) => {
        if ('data' in res) {
          window.open(`${API_DOMAIN}${res.data?.data.downloadurl}`, '_self')
        } else if ('error' in res) {
          toast.error(res.error)
          console.error('Error export:', res.error)
        }
      })
      .catch((err) => {
        toast.error(err.error)
      })
  }, [API_DOMAIN, ProfileDetatileState?._id, endDate, exportData, startDate])

  const handleSearchEnter = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      setTriggerFetch(true)
    }
  }

  return (
    <>
      <SalesTarget show={isSalesTargetModal} handleClose={() => setIsSalesTargetModal(false)} />
      <div className={`sub-accountstable card `}>
        <div className='card'>
          <div className='card-body'>
            <div className='d-flex flex-wrap flex-sm-nowrap'>
              <div className='flex-grow-1'>
                <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                  <div className='d-flex flex-column'>
                    <div className='d-flex align-items-center mb-2'>
                      <span className='text-gray-900 text-hover-primary fs-2 fw-bolder me-1'>
                        Commission
                      </span>
                    </div>
                  </div>

                  <div className='d-flex mb-3'>
                    {
                      <div
                        className='card-toolbar'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-trigger='hover'
                        title='Click to add a user'
                      >
                        <div className='d-flex align-items-center position-relative my-1'>
                          <KTSVG
                            path='/media/icons/duotune/general/gen021.svg'
                            className='svg-icon-1 position-absolute ms-6'
                          />
                          <div className='d-flex'>
                            <DatePicker
                              selectsRange={true}
                              dateFormat='MMM d, yyyy'
                              className=' border-0 form-control form-control-lg form-control-solid'
                              placeholderText='Pick data & time'
                              onChange={(update: any) => {
                                setDateRange(update)
                              }}
                              startDate={startDate}
                              endDate={endDate}
                              disabled={commissionLoading}
                            />
                            <span
                              className='input-group-text'
                              style={{
                                backgroundColor: '#f5f8fa',
                                borderRadius: 0,
                                borderColor: '#f5f8fa',
                              }}
                            >
                              <i className='bi bi-calendar'></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className='d-flex flex-wrap flex-sm-nowrap'>
          <div className='flex-grow-1'>
            <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
              <div className='d-flex flex-column col-lg-12'>
                <div className='row'>
                  <div className='col-lg-12'>
                    <div className='row'>
                      {commissionLoading && (
                        <div className='text-center'>
                          <Spinner />
                        </div>
                      )}

                      <div className='col-lg-12'>
                        <div
                          className=' d-flex justify-content-center align-items-center'
                          style={{ minHeight: 100 }}
                        >
                          <h1 className='fw-bolder m-0' style={{ fontSize: 40 }}>
                            $
                            {commissionData?.data
                              ?.reduce((a, b) => a + b?.commission, 0)
                              ?.toFixed(2)}
                          </h1>
                        </div>
                        <div className='text-center mb-5'>
                          <h4 className='fw-bolder m-0 fs-6'>Total Commission</h4>
                        </div>
                      </div>

                      {commissionData?.data?.map((it) => {
                        return (
                          <div className='col-lg-6'>
                            <div
                              className=' d-flex justify-content-center align-items-center'
                              style={{ minHeight: 100 }}
                            >
                              <h1 className='fw-bolder m-0' style={{ fontSize: 40 }}>
                                ${it.commission?.toFixed(2)}
                              </h1>
                            </div>
                            <div className='text-center mb-5'>
                              <h4 className='fw-bolder m-0 fs-6'>
                                Total {it?._id.toUpperCase()} Commission
                              </h4>
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='card mt-6'>
        <div className='card-header border-0 p-0 align-items-center mb-10'>
          <div className='d-flex flex-column w-100'>
            <h3 className='card-title align-items-start  flex-column'>
              <span className='card-label fw-bolder fs-2 mb-1'>Coupons</span>
            </h3>
            <div className='d-flex justify-content-between align-items-center w-100 mt-2'>
              <div className='col-md-6'>
                <div className='d-flex gap-4'>
                  <div className='d-flex align-items-start col-md-8 me-2'>
                    <KTSVG
                      path='/media/icons/duotune/general/gen021.svg'
                      className='svg-icon-1 position-absolute ms-6 mt-3'
                    />
                    <input
                      type='text'
                      value={params.search ? params.search : ''}
                      data-kt-user-table-filter='search'
                      className='form-control form-control-solid w-170px ps-14'
                      placeholder='Search by code'
                      onChange={(e: any) => setParams({ ...params, search: e.target.value, page: 1 })}
                      onKeyDown={handleSearchEnter}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {isLoadingCoupon ? (
          <div className='row flex-center h-200'>
            <Spinner />
          </div>
        ) : (
          <>
            {data?.data?.items && data?.data?.items.length > 0 ? (
              <div className='card-body p-0 pt-1'>
                <div className='table-responsive'>
                  <table className='table align-middle gs-0 gy-5 all-message-table'>
                    <thead>
                      <tr className='fw-400 text-muted'>
                        <th className='min-w-140px'>Code</th>
                        <th className='min-w-120px'>Type</th>
                        <th className='min-w-140px'>Coupon Type</th>
                        <th className='min-w-140px'>Value</th>
                        <th className='min-w-140px'>Staff</th>
                        <th className='min-w-140px'>Commission Rate</th>
                        <th className='min-w-140px'>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {isFetching ? (
                        <tr>
                          <td colSpan={20} className='text-center'>
                            <Spinner />
                          </td>
                        </tr>
                      ) : (
                        <>
                          {data?.data?.items && data?.data?.items?.map((item, i: number) => (
                            <React.Fragment key={i}>
                              <tr className='border-dashed border-2 border-bottom'>
                                <td className='top-align'>
                                  <div className='d-flex gap-2 align-items-center'>
                                    <span>{item?.code || '--'}</span>
                                    <WSButton
                                      onClick={() => {
                                        navigator.clipboard.writeText(item?.code)
                                        toast.success('Copied!')
                                      }}
                                      data-action='copy'
                                      className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'
                                    >
                                      <span className='svg-icon svg-icon-2'>
                                        <svg
                                          xmlns='http://www.w3.org/2000/svg'
                                          width='24'
                                          height='24'
                                          viewBox='0 0 24 24'
                                          fill='none'
                                        >
                                          <path
                                            opacity='0.5'
                                            d='M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z'
                                            fill='currentColor'
                                          />
                                          <path
                                            fill-rule='evenodd'
                                            clipRule='evenodd'
                                            d='M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z'
                                            fill='currentColor'
                                          />
                                        </svg>
                                      </span>
                                    </WSButton>
                                  </div>
                                </td>
                                <td className='top-align'>{item?.type || '--'}</td>
                                <td className='top-align'>{showDiscountType(item).title}</td>
                                <td className='top-align'>{showDiscountType(item).value}</td>
                                <td className='top-align'>{item?.staffId?.name || '--'}</td>
                                <td className='top-align'>{item?.commisionRate || '--'}%</td>
                                <td>
                                  <span
                                    className={`${item?.status ? 'badge badge-light-success ' : 'badge badge-light-danger'
                                      }`}
                                  >
                                    {item?.status ? 'Active' : 'Inactive'}
                                  </span>
                                </td>
                              </tr>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : (
              <NodataYet message='No Coupon (yet!)' />
            )}
          </>
        )}
      </div>

      <div className='card mt-6'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Commission History</h3>
          </div>
          <div className='card-toolbar m-0'>

            <div className='d-flex align-items-center'>
              {userDetail?.role === ROLES.SUPER_ADMIN ? (
                <button
                  type='button'
                  className='btn btn-primary btn-md ms-2'
                  onClick={() => setIsSalesTargetModal(true)}
                >
                  Target
                </button>
              ) : null}
              <button
                type='button'
                className='btn btn-primary btn-md ms-2'
                onClick={() => handleExports()}
              >
                {isLoading ? <Spinner /> : 'Export'}
              </button>
            </div>
          </div>
        </div>
        <div className='card-body py-3'>
          {commissionListData?.data?.items?.length ? (
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bolder text-muted'>
                    <th className='min-w-50px' style={{ verticalAlign: 'top' }}>
                      CREATED
                    </th>
                    <th className='min-w-50px' style={{ verticalAlign: 'top' }}>
                      USER
                    </th>
                    <th className='min-w-50px' style={{ verticalAlign: 'top' }}>
                      TYPE
                    </th>
                    <th className='min-w-50px' style={{ verticalAlign: 'top' }}>
                      COUPON
                    </th>
                    <th className='min-w-50px' style={{ verticalAlign: 'top' }}>
                      VOlUME
                    </th>
                    <th
                      className='min-w-50px'
                      style={{
                        maxWidth: 150,
                        wordBreak: 'break-word',
                        whiteSpace: 'normal',
                        verticalAlign: 'top',
                      }}
                    >
                      TOTAL AMOUNT WITHOUT GST
                    </th>
                    <th className='min-w-100px' style={{ verticalAlign: 'top' }}>
                      TOTAL COG
                    </th>
                    <th className='min-w-50px' style={{ verticalAlign: 'top' }}>
                      RATE
                    </th>
                    <th className='min-w-100px' style={{ verticalAlign: 'top' }}>
                      COMMISSION
                      <i
                        className='bi bi-info-circle-fill ms-2'
                        style={{ color: '#3498db' }}
                        data-bs-toggle='tooltip'
                        title='(TOTAL AMOUNT WITHOUT GST - TOTAL COG) * RATE'
                      ></i>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {commissionListData?.data?.items?.map((data: any, idx: number) => (
                    <tr key={idx}>
                      <td>{moment(data?.createdAt).format('DD/MM/YYYY')}</td>
                      <td>{data?.name || '-'}</td>
                      <td>{data?.type}</td>
                      <td>{data?.coupon}</td>
                      <td>{data?.allowedMessages}</td>
                      <td>${data?.totalAmountWithoutGST?.toFixed(2) || 0}</td>
                      <td>${data?.totalAmountCOG?.toFixed(2)}</td>
                      <td>{data?.commissionRate ? `${data?.commissionRate}%` : '-'}</td>
                      <td>${data?.commission?.toFixed(2)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className='pull-right'>
                <div className='abcd '>
                  <ReactPaginate
                    previousLabel='<'
                    nextLabel='>'
                    pageCount={commissionListData?.data?.totalPages || 1}
                    onPageChange={(e) => setPage({ ...page, page: e.selected + 1 })}
                    containerClassName={'pagiantion'}
                    previousLinkClassName={'pagination__link'}
                    nextLinkClassName={'pagination__link'}
                    disabledClassName={'pagination__link--disabled'}
                    activeClassName={'pagination__link--active'}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className='text-center'>{commissionListLoading ? <Spinner /> : <NodataYet />}</div>
          )}
        </div>
      </div>
    </>
  )
}

export default Commission
